const orderByObjectNumber = (prop, desc = false) => (a, b) => {
  const propA = a[prop] ? a[prop] : null;
  const propB = b[prop] ? b[prop] : null;

  if (!desc) {
    if (propA < propB) {
      return -1;
    }
    if (propA > propB) {
      return 1;
    }
  } else {
    if (propB < propA) {
      return -1;
    }
    if (propB > propA) {
      return 1;
    }
  }

  return 0;
};

export { orderByObjectNumber };
